// extracted by mini-css-extract-plugin
module.exports = {"page":"HomePage_page__GxZm5","carousel":"HomePage_carousel__nM6dI","information":"HomePage_information__2j5co"};